module.exports = __webpack_public_path__ + "static/Monda-Regular-69a1a489cece44aac1c49443b5acda89.woff2";